
  export default {
    props: { bundle: { type: Object, required: true } },
    data () {
      return { tooltipContent: null };
    },
    computed: {
      tooltipOptions () {
        let opts = { classes: 'listItemTooltip', content: this.tooltipContent };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    },
    mounted () {
      const el = this.$el.querySelector('.temporaryToolTip');
      this.tooltipContent = el.innerHTML;
      el.remove();
    }
  };
